import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Link } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    wrap: {
        width: '100%',
        padding: '5px',
        marginTop: '20px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    head: {
        backgroundColor: '#fff',
        border: '2px solid #000',
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
        borderBottom: 'none',
    },
    parentTop: {
        display: 'flex',
    },
    parentBottom: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    childImage: {
        width: '30%',
        marginRight: '10px',
        marginLeft: '20px',
        position: 'relative'
    },
    personImage: {
        width:  '90px',
        verticalAlign: 'bottom',
        position: 'absolute',
        bottom: 0
    },
    childTitleWrap: {
        width: '70%',
        marginTop: '10px',
        marginRight: '10px'
    },
    childTitle: {
        marginTop: '10px',
        fontSize: '20px',
        fontWeight: 'bold',
        color: 'blue',
        textAlign: 'center'
    },
    childLine: {
        border: '1px solid #000',
        marginTop: '5px',
        marginBottom: '5px',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '90%',
        height: '1px'
    },
    child: {
        fontSize: '1rem',
        paddingLeft: '3%',
        paddingRight: '3%'
    },
    childFooter: {
        paddingTop: '10px',
        paddingBottom: '5px',
        border: '2px solid #000',
        borderTop: 'none',
        borderBottomLeftRadius: '20px',
        borderBottomRightRadius: '20px',
        backgroundColor: '#C7DFC2',
    },
    childMobile: {
        width: '10%',
        marginRight: '10px',
        marginLeft: '10px'
    },
    mobileImage: {
        width: '100%'
    },
    childTel: {
        width: '50%',
        fontSize: '1rem'
    },
    childTelString: {
        marginLeft: '15px'
    },
    childTelImage: {
    },
    childTime: {
        width: '40%',
        fontSize: '.8rem',
        textAlign: 'center'
    },
    childFaq: {
        width: '50%',
        marginLeft: '10px',
        marginRight: '5px'
    },
    childConfirm: {
        width: '50%',
        marginLeft: '5px',
        marginRight: '10px'
    },
    anchorWrap: {
        marginTop: '10px',
        marginBottom: '20px',
    },
    anchor: {
        fontSize: '18px',
        backgroundColor: 'skyblue'
    },
    attention: {
        fontSize: '12px',
        padding: '0.5em'
    }
}));

// 説明
function GuideHalf(props){
    const classes = useStyles();

    const handleScrollTop = () => {
        window.scrollTo(0, 0);
    }

    return(
        <div className={classes.wrap}>
            {
                (() => {
                    if(props.pageName){
                        return (
                            <div className={classes.anchorWrap}>
                                <Link className={classes.anchor} onClick={handleScrollTop}>{props.pageName}の先頭に戻る</Link>
                            </div>
                        )
                    }else{
                        return (
                            <div className={classes.anchorWrap}>
                            </div>
                        )
                    }
                })()
            }
            <div className={classes.head}>
                <div className={classes.childTitle}>
                    自筆証書遺言・財産目録の作成は弁護士に相談できます。
                </div>
                <div className={classes.childLine}>&nbsp;</div>
                <div className={classes.parentTop}>
                    <div className={classes.childImage}>
                        <img src="img/person.png" className={classes.personImage} />
                    </div>
                    <div className={classes.childTitleWrap}>
                        <div className={classes.child}>
                            このサイトでは、ご自身で無料で自筆証書遺言と財産目録がかんたんに作成できます。<br />
                            しかし、弁護士にしっかり相談して作成したい場合は、
気軽に相談する事も可能です。
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.childFooter}>
                <div className={classes.parentBottom}>
                    <div className={classes.childMobile}>
                        <img src="img/mobile.png" className={classes.mobileImage} />
                    </div>
                    <div className={classes.childTel}>
                        <div className={classes.childTelString}>
                            お電話で弁護士へご相談はこちら
                        </div>
                        <div>
                            <img src="img/tel.png" className={classes.childTelImage} />
                        </div>
                    </div>
                    <div className={classes.childTime}>
                        <div>
                            受付時間
                        </div>
                        <div>
                            平日 10:00 〜 17:00<br/>
                            (年末年始除く)
                        </div>
                    </div>
                </div>
                <div className={classes.attention}>
                    ※お電話をいただく際「遺言相続コンサルティングのホームページを見ました」とお伝えいただくとスムーズにご案内致します。
                </div>
                <div className={classes.parentBottom}>
                    <div className={classes.childFaq}>
                        <a href="https://igon-sozoku.jp/qa/">
                            <img src="img/faq.png" />
                        </a>
                    </div>
                    <div className={classes.childConfirm}>
                        <a href="https://igon-sozoku.jp/inform/">
                            <img src="img/confirm.png" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GuideHalf
